import { useRef, useEffect } from "react"

interface HtmlDisplayProps {
    content: string
    name: string
}
export function HtmlDisplay({ content, name }: Readonly<HtmlDisplayProps>) {
    const iframeRef = useRef<HTMLIFrameElement>(null)

    useEffect(() => {
        if (iframeRef.current) {
            const iframe = iframeRef.current

            const resizeIframe = () => {
                try {
                    const doc = iframe.contentDocument || (iframe.contentWindow as Window).document
                    if (doc && doc.documentElement) {
                        iframe.style.height = doc.documentElement.scrollHeight + "px"
                    }
                } catch (error) {
                    console.warn("Unable to resize iframe:", error)
                }
            }

            iframe.onload = resizeIframe
            const timeoutId = setTimeout(resizeIframe, 100)
            window.addEventListener("resize", resizeIframe)

            return () => {
                window.removeEventListener("resize", resizeIframe)
                clearTimeout(timeoutId)
            }
        }
    }, [content])

    return <iframe ref={iframeRef} srcDoc={content} height="100%" width="100%" title={name} style={{ border: "none" }} />
}
